import moment from "moment";

export const LoginErrorMsg =
  "There was an error logging in, please check your email and password and try again.";

export const LoginErrorAccountDisabled =
  "Your account is suspended, please contact Moblyze";

export const formatStartDate = (date) => {
  if (!date) {
    return "";
  }

  // Use UTC mode to prevent timezone conversion
  // This ensures the date selected matches the date displayed
  const m = moment.utc(date);

  return m.format("MMM D, YYYY");
};

export const formatPayFrequency = (payFrequency) => {
  if (payFrequency === "Daily") return "/Day";
  if (payFrequency === "Monthly") return "/Month";
  if (payFrequency === "Yearly") return "/Year";
  return " " + payFrequency;
};

export const getDisplaySalary = (obj) => {
  const value = obj?.payRateValue;
  const currency = obj?.payCurrency || "";
  const frequency = obj?.payFrequency || "";

  if (!value) return "Negotiable";

  return `${value} ${currency}${formatPayFrequency(frequency)}`;
};
